import { useTranslation } from 'react-i18next';
import { ViewClaimDetailsResponse } from 'all-in-one-shared-api';
import { Button, Typography } from 'antd';

import { FullWidthSpace } from 'components';
import { StyledTitle } from 'components/StyledTitle';
import { TitleSection, WhiteDescriptions as Descriptions } from '../styledComponents';
import { useNavigate } from 'react-router-dom';

type ShortfallInformationProps = Pick<
  ViewClaimDetailsResponse,
  'shortfallAmount' | 'daysOverdue' | 'claimId' | 'sequenceNo'
> & { btnDisabled?: boolean };

export const ShortfallInformation = ({
  shortfallAmount,
  daysOverdue = 0,
  claimId,
  sequenceNo,
  btnDisabled = false,
}: ShortfallInformationProps): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goToSettle = () => {
    navigate({
      pathname: '/claims/shortfall/settle',
      search: `?claimId=${claimId}&sequenceNo=${sequenceNo}`,
    });
  };

  return (
    <div>
      <TitleSection>
        <StyledTitle level={5}>{t('claimDetails.shortfall.information.title')}</StyledTitle>
      </TitleSection>

      <FullWidthSpace direction="vertical" size="middle">
        <Descriptions bordered column={2}>
          <Descriptions.Item label={t('claimDetails.shortfall.information.shortfallAmount')}>
            <Typography.Text type="danger">
              {shortfallAmount?.currency || ''} {shortfallAmount?.amount || ''}
            </Typography.Text>
          </Descriptions.Item>

          <Descriptions.Item span={2} label={t('claimDetails.shortfall.information.daysOverdue')}>
            <Typography.Text>{daysOverdue}</Typography.Text>
          </Descriptions.Item>
        </Descriptions>

        <Button type="primary" color="var(--primary-color)" size="large" onClick={goToSettle} disabled={btnDisabled}>
          {t('claimDetails.shortfall.information.settleShortfall')}
        </Button>
      </FullWidthSpace>
    </div>
  );
};
